import React from "react";
import { libraryColumns } from "../../data/intelligence";
import { SectionLabel } from "../SectionLabel";
const cellBorders = ["", "md:border-l md:pl-8", "lg:border-l lg:pl-8 md:border-l-0 md:pl-0", "md:border-l md:pl-8"];
export function LibraryIndex() {
  return <section aria-labelledby="library-title" className="shell pb-24 md:pb-32" data-id="element-376" data-mp="1u4l4s92cjgtl">
      <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-12" data-id="element-377" data-mp="1u6o4jktawobi">
        <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-378" data-mp="1y553vi6hcuid">
          <SectionLabel data-id="element-379" data-mp="2359mbdqy7zb8">The library</SectionLabel>
        </div>
        <div className="col-span-12 lg:col-span-9" data-id="element-380" data-mp="233ey9qkdrr2x">
          <h2 id="library-title" className="font-display text-[clamp(2.25rem,4.2vw,3.5rem)] leading-[1.06] text-navy" data-id="element-381" data-mp="283t9til6xj5p">
            Systems, playbooks, issues, and research — filed together.
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 border-t border-navy md:grid-cols-2 lg:grid-cols-4" data-id="element-382" data-mp="drmss35m885h">
        {libraryColumns.map((col, i) => <div key={col.title} className={`border-b border-stone py-8 pr-6 lg:border-b-0 ${cellBorders[i]}`} data-id="element-383" data-mp="ir96set9psfc" data-mpi={i}>
            <div className="flex items-baseline justify-between gap-4" data-id="element-384" data-mp="casm8jj0fzkm">
              <h3 className="font-display text-2xl leading-tight text-navy" data-id="element-385" data-mp="c8pofdbm925c">{col.title}</h3>
              <span className="shrink-0 text-sm tabular-nums text-oxblood" data-id="element-386" data-mp="7bz94s7myakz">{col.count}</span>
            </div>
            <ul className="mt-6 border-t border-stone" data-id="element-387" data-mp="2ajqt7wuei6a">
              {col.items.map(item => <li key={item} className="border-b border-stone py-3 text-sm leading-snug text-charcoal/80" data-id="element-388" data-mp="zyaj2th4tnug">
                  {item}
                </li>)}
            </ul>
          </div>)}
      </div>
    </section>;
}